module.exports = __webpack_public_path__ + "static/media/One side Angle's Class II15.d7ca3a70.png";